__turbopack_context__.v({
  "activeTab": "NetworkingScripts-module__mxlJoq__activeTab",
  "checkIcon": "NetworkingScripts-module__mxlJoq__checkIcon",
  "container": "NetworkingScripts-module__mxlJoq__container",
  "content": "NetworkingScripts-module__mxlJoq__content",
  "copyButton": "NetworkingScripts-module__mxlJoq__copyButton",
  "customizationTips": "NetworkingScripts-module__mxlJoq__customizationTips",
  "doAndDontSection": "NetworkingScripts-module__mxlJoq__doAndDontSection",
  "doColumn": "NetworkingScripts-module__mxlJoq__doColumn",
  "dontColumn": "NetworkingScripts-module__mxlJoq__dontColumn",
  "emptyState": "NetworkingScripts-module__mxlJoq__emptyState",
  "expandIcon": "NetworkingScripts-module__mxlJoq__expandIcon",
  "expanded": "NetworkingScripts-module__mxlJoq__expanded",
  "followUpBox": "NetworkingScripts-module__mxlJoq__followUpBox",
  "header": "NetworkingScripts-module__mxlJoq__header",
  "infoBox": "NetworkingScripts-module__mxlJoq__infoBox",
  "scriptCard": "NetworkingScripts-module__mxlJoq__scriptCard",
  "scriptContent": "NetworkingScripts-module__mxlJoq__scriptContent",
  "scriptHeader": "NetworkingScripts-module__mxlJoq__scriptHeader",
  "scriptInfo": "NetworkingScripts-module__mxlJoq__scriptInfo",
  "scriptsList": "NetworkingScripts-module__mxlJoq__scriptsList",
  "section": "NetworkingScripts-module__mxlJoq__section",
  "strategyTab": "NetworkingScripts-module__mxlJoq__strategyTab",
  "subtitle": "NetworkingScripts-module__mxlJoq__subtitle",
  "tab": "NetworkingScripts-module__mxlJoq__tab",
  "tabIcon": "NetworkingScripts-module__mxlJoq__tabIcon",
  "tabIntro": "NetworkingScripts-module__mxlJoq__tabIntro",
  "tabLabel": "NetworkingScripts-module__mxlJoq__tabLabel",
  "tabNav": "NetworkingScripts-module__mxlJoq__tabNav",
  "targetPeopleList": "NetworkingScripts-module__mxlJoq__targetPeopleList",
  "targetPerson": "NetworkingScripts-module__mxlJoq__targetPerson",
  "targetRole": "NetworkingScripts-module__mxlJoq__targetRole",
  "targetWhy": "NetworkingScripts-module__mxlJoq__targetWhy",
  "templateBox": "NetworkingScripts-module__mxlJoq__templateBox",
  "templateHeader": "NetworkingScripts-module__mxlJoq__templateHeader",
  "templateText": "NetworkingScripts-module__mxlJoq__templateText",
  "tipCard": "NetworkingScripts-module__mxlJoq__tipCard",
  "tipCategory": "NetworkingScripts-module__mxlJoq__tipCategory",
  "tipsGrid": "NetworkingScripts-module__mxlJoq__tipsGrid",
  "title": "NetworkingScripts-module__mxlJoq__title",
  "xIcon": "NetworkingScripts-module__mxlJoq__xIcon",
});
